<template>
    <div v-if="webInfo">
        <div class="majorInfo">
            <div class="majorInfoDetails">
                <video class="majorInfoVideo" :src="globalConfig.filePath + webInfo.WidgetMajor.part1.majorInfoVideo" preload="auto" poster controls></video>
                <div class="majorInfoContent">
                    <p v-for="(item, index) in webInfo.WidgetMajor.part1.majorInfoContent" :key="index">{{item}}</p>
                </div>
            </div>
        </div>

        <div class="elementTitle">{{webInfo.WidgetMajor.part2.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetMajor.part2.elementLabel}}</div>
        <div class="majorListDiv">
            <el-row :gutter="15" style="margin-top: 15px">
                <el-col class="majorCard" :span="8" v-for="(item, index) in webInfo.WidgetMajor.part2.majorList" :key="index">
                    <el-card :body-style="{ padding: '0px' }">
                        <el-image lazy style="height: auto;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                        <div class="majorCardInfo">
                            <p class="majorName">{{item.majorName}}</p>
                            <p class="majorTips">{{item.majorTips}}</p>
                            <p class="majorDetails">
                                <span style="font-weight: bold;">升学方向：</span>
                                <span>{{item.majorDetails1}}</span>
                            </p>
                            <p class="majorDetails">
                                <span style="font-weight: bold;">就业方向：</span>
                                <span>{{item.majorDetails2}}</span>
                            </p>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
        },
        methods: {},
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .majorInfo {
        width: 100%;
        height: auto;
        margin: 0 auto;
        position: relative;
        padding: 50px 0;
        box-sizing: border-box;
    }

    .majorInfoDetails {
        display: flex;
        justify-content: space-between;
        width: 65%;
        margin: 0 auto;
        height: 330px;
        overflow: hidden;
    }

    .majorInfoVideo {
        height: 330px;
        width: auto;
        margin-right: 30px;
    }

    .majorInfoContent {
        height: 330px;
        overflow: auto;
        font-size: 14px;
        line-height: 25px;
        min-width: 300px;
    }

    .majorInfoContent p {
        margin-bottom: 10px;
    }

    .majorListDiv {
        width: 65%;
        margin: 0 auto;
    }

    .majorListDiv >>> img {
        transition: 0.3s;
    }

    .majorListDiv >>> img:hover {
        transform: scale(1.1);
    }

    .majorListDiv .majorName {
        width: 100%;
        font-size: 26px;
        font-weight: bold;
        text-align: center;
        line-height: 50px;
    }

    .majorCardInfo {
        height: 250px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .majorListDiv .majorTips {
        width: 100%;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
        color: #236de9;
        margin-bottom: 10px;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-inline-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    .majorListDiv .majorCard {
        padding: 7.5px;
    }

    .majorDetails {
        width: 100%;
        height: 60px;
        font-size: 14px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-inline-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    .majorDetails + .majorDetails {
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetMajor.vue